import { useRef, useEffect } from "react"

/**
 * Stores the previous value of a stateful variable. Useful for comparing
 * changes inside useEffect. Example:
 *
 * ```js
 * const [foo, setFoo] = useState()
 * const previousFoo = usePrevious(foo)
 *
 * useEffect(() => {
 *   if (previousFoo === "someValue") {
 *      // ...
 *   }
 * }, [foo])
 * ```
 */
export default function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T | undefined>()

  useEffect(() => {
    ref.current = value
  })

  return ref.current
}
